import { API_BASE } from "../config";
import { createContext, useEffect, useState } from "react";

export const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loadingUser, setLoadingUser] = useState(true);

  useEffect(() => {
    const loadUser = async () => {
      try {
        const res = await fetch(`${API_BASE}/login/me`, {
          credentials: "include",
        });
        const data = await res.json();
        if (data.status !== 0) {
          setUser(null);
          return null;
        }
        if (data.status === 0) {
          const userRes = await fetch(
            `${API_BASE}/Users/${data.id}`
          );
          const detail = await userRes.json();

          setUser(detail);
        }
      } catch (err) {
        console.log("load user error:", err);
      } finally {
        setLoadingUser(false);
      }
    };

    loadUser();
  }, []);
  if (loadingUser) return null;
  return (
    <UserContext.Provider value={{ user, setUser, loadingUser }}>
      {children}
    </UserContext.Provider>
  );
};
